import {
  FileUpload,
  FileUploadProps,
} from '@/decodo/components/atoms/FileUpload';
import { Text } from '@/decodo/components/atoms/Text';

interface FileUploadFormControlProps extends FileUploadProps {
  inputLabel: React.ReactNode | string;
  error?: string;
  acceptedFileTypes: string[];
}

export const FileUploadField = ({
  name,
  value,
  label,
  inputLabel,
  error,
  acceptedFileTypes,
  onBlur,
  onChange,
  onFileRemove,
}: FileUploadFormControlProps) => (
  <div>
    <Text
      variant='body-m'
      classNames={{
        wrapper: error ? 'text-error-500 pb-2' : 'text-gray-500 pb-2',
      }}
    >
      {typeof label === 'string' ? <p>{label}</p> : label}
    </Text>
    <FileUpload
      classNames={{ root: 'pb-5 md:pb-4' }}
      label={inputLabel}
      name={name}
      value={value}
      accept={acceptedFileTypes.join(',')}
      onChange={onChange}
      onBlur={onBlur}
      onFileRemove={onFileRemove}
    />
  </div>
);
